"use client";

import { c as _c } from "react/compiler-runtime";
import { LightboxPublicController } from "@multi-tenant-cms/builder/runtime/lightboxPublicRuntime";
import type { ResolvedLightboxPublic } from "@multi-tenant-cms/builder/ui/types/lightbox";
export function LightboxPublicRuntimeClient(t0) {
  const $ = _c(2);
  const {
    lightboxes
  } = t0;
  if (lightboxes.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== lightboxes) {
    t1 = <LightboxPublicController lightboxes={lightboxes} />;
    $[0] = lightboxes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}